<template>
<div class='profile'>
  <div class='nav'>
    <el-menu class='theme-primary' :default-active="$route.path" router>
      <el-menu-item index="/profile">账户概况</el-menu-item>
      <!-- <el-menu-item index="/profile/bills">历史账单</el-menu-item> -->
      <!--<el-menu-item index="/profile/income">我的收入</el-menu-item>-->
      <el-menu-item index="/profile/development" v-if="apiEnabled">开发信息</el-menu-item>
    </el-menu>
  </div>
  <router-view class="sub-profile"></router-view>
</div>
</template>

<script>
export default {
  computed: {
    apiEnabled() {
      return this.$store.state.user.info.api_entitled || (this.$store.getters['user/organization'] && this.$store.getters['user/organization'].api_entitled)
    }
  }
}
</script>

<style lang='scss' scoped>
.profile {
    position: relative;
    padding: 30px;
    $nav-width: 240px;
    .nav {
        float: left;
        position: absolute;
        width: $nav-width;
        top: $padding-page-container;
        min-height: 480px;
        background-color: $color-white-base;
        padding-top: $padding-base;
        box-shadow: $box-shadow-base;
    }

    .sub-profile {
        padding-left: $nav-width + $margin-base;
        width: 100%;
        min-height: 600px;
    }
}
</style>



// WEBPACK FOOTER //
// index.vue?7158102c